import { logger } from '@/lib/logger';

/**
 * XState Inspector Setup for Development
 * 開発環境でのみ状態遷移を可視化
 */

declare global {
  interface Window {
    __XSTATE_DEVTOOLS__: boolean;
  }
}

export function setupXStateInspector() {
  if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
    // XState v5では@statelyai/inspectを使用（将来的に）
    // 現在はブラウザの開発者ツールでのログ出力で代替
    logger.info('[XState Inspector] Development mode - State transitions will be logged');

    // グローバルオブジェクトに状態機械を公開（デバッグ用）
    window.__XSTATE_DEVTOOLS__ = true;
  }
}

// 状態遷移のログ関数
export function logStateTransition(
  machineName: string,
  from: string,
  to: string,
  event: { type: string }
) {
  if (process.env.NODE_ENV === 'development') {
    logger.info(`[${machineName}] ${from} → ${to} (event: ${event.type})`);
  }
}
